import { render } from "./Mondhygiene.vue?vue&type=template&id=a44520ea&scoped=true"
import script from "./Mondhygiene.vue?vue&type=script&lang=js"
export * from "./Mondhygiene.vue?vue&type=script&lang=js"

import "./Mondhygiene.vue?vue&type=style&index=0&id=a44520ea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a44520ea"]])

export default __exports__